const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaitingTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-1"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.8,
    y: 95.61,
    width: 135.7,
    height: 286.79,
    transform: "translate(269.29 478.01) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.78,
    y: 95.61,
    width: 135.7,
    height: 286.79,
    transform: "translate(263.26 478.01) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -5.68,
    y: 176.57,
    width: 274.63,
    height: 124.87,
    transform: "translate(370.64 107.37) rotate(90)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.31 376.32 133.67 101.69 97.95 101.69 129.59 376.32 165.31 376.32",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: -66.98,
    y: 237.86,
    width: 274.63,
    height: 2.28,
    transform: "translate(309.34 168.67) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.02,
    y: 125.48,
    width: 131.22,
    height: 8.16,
    transform: "translate(263.26 259.12) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.63,
    y: 271.8,
    width: 166.4,
    height: 54.79,
    transform: "translate(546.03 52.37) rotate(90)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.44,
    y: 220.86,
    width: 48.77,
    height: 48.77,
    transform: "translate(492.08 -1.58) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.44,
    y: 274.01,
    width: 48.77,
    height: 48.77,
    transform: "translate(545.23 51.57) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.44,
    y: 327.17,
    width: 48.77,
    height: 48.77,
    transform: "translate(598.39 104.72) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.63,220.22H236a5,5,0,0,0,5.05,5.05h11.48A5.06,5.06,0,0,0,257.63,220.22Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.63,273.37H236a5.06,5.06,0,0,0,5.05,5.06h11.48A5.07,5.07,0,0,0,257.63,273.37Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.63,326.52H236a5.06,5.06,0,0,0,5.05,5.06h11.48A5.07,5.07,0,0,0,257.63,326.52Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.71,
    y: 285.52,
    width: 166.4,
    height: 27.37,
    transform: "translate(587.11 11.29) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.49,
    y: 253.03,
    width: 15.19,
    height: 125.28,
    transform: "translate(856.17 631.34) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.71,
    y: 378.31,
    width: 145.86,
    height: 4.09,
    transform: "translate(721.29 760.71) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.61,
    y: 253.03,
    width: 134.88,
    height: 125.28,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,326.24h82.06a14.61,14.61,0,1,0,0-29.22H312a14.61,14.61,0,1,0,0,29.22ZM394.08,298a13.63,13.63,0,1,1,0,27.26H312A13.63,13.63,0,0,1,312,298Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,362.59h82.06a14.61,14.61,0,0,0,0-29.22H312a14.61,14.61,0,0,0,0,29.22Zm82.06-28.24a13.63,13.63,0,1,1,0,27.25H312a13.63,13.63,0,1,1,0-27.25Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.67,308.48h24.76a3.06,3.06,0,0,0,3.05-3.05h0a3.06,3.06,0,0,0-3.05-3.05H340.67a3.06,3.06,0,0,0-3.05,3.05h0A3.06,3.06,0,0,0,340.67,308.48Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,289.89h82.06a14.61,14.61,0,1,0,0-29.22H312a14.61,14.61,0,1,0,0,29.22Zm82.06-28.24a13.63,13.63,0,0,1,0,27.26H312a13.63,13.63,0,1,1,0-27.26Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.67,272.13h24.76a3.06,3.06,0,0,0,3.05-3.05h0a3.05,3.05,0,0,0-3.05-3H340.67a3.05,3.05,0,0,0-3.05,3h0A3.06,3.06,0,0,0,340.67,272.13Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.67,344.82h24.76a3.05,3.05,0,0,0,3.05-3h0a3.06,3.06,0,0,0-3.05-3H340.67a3.06,3.06,0,0,0-3.05,3h0A3.05,3.05,0,0,0,340.67,344.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.84,
    y: 246.67,
    width: 137.65,
    height: 6.37,
    transform: "translate(703.32 499.7) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.49,
    y: 246.67,
    width: 18.17,
    height: 6.37,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,146.39c3.07,1.54,11.39-.12,8.62,5.51a46.81,46.81,0,0,1-5.69,8.26c-3.1,3.83-2.51,8,1.15,9.48a4.41,4.41,0,0,1,2,1.4c1.69,2.42-2.29,5.66-4.25,8.08s-2.74,4.8-1.3,6.6c1.6,2,4.92,1.25,7.56,1.85,6.34,1.45-.18,10.2.49,14.69.46,3.08,3,3.94,6.35,4.37,2.77.36,6.46.61,6.61,3.44.14,2.46-3.06,5.24-3.9,7.82a8.09,8.09,0,0,0,.62,6.8,7.43,7.43,0,0,0,5,3.26c3.14.66,7.89,0,8.12,3.52.1,1.58-1,3-.24,4.44a5.1,5.1,0,0,0,3.69,2.17,26.91,26.91,0,0,0,9.06-.16c3.69-.68,9.14-3.93,7.14-7.06a4.28,4.28,0,0,0-2.86-1.64c-.88-.18-3.46.1-3.79-.5s.56-2.91.59-3.74a17.57,17.57,0,0,0-1.07-6.77,20.65,20.65,0,0,0-4.76-7.54c-.88-.89-2.27-1.54-2.45-2.83s.63-2.71,1.53-4c1.41-2,3.6-3.88,4.39-6,1.24-3.34-1.77-4.4-4.56-5.16-2.52-.69-5.84-1.57-5-4.63.62-2.21,3.41-4,4.24-6.18,1.13-2.89-1.61-3-3.56-4-2.55-1.34-3.19-3.74-2.27-6.77,1.53-5,10.7-12.07,6-15.32-1.19-.83-2.3-1.1-3-2.35s-.88-3-1.88-4.18c-1.58-1.91-4.85-2.23-6.55-4-3.51-3.64,4.06-10.09-2.85-11.63a8.2,8.2,0,0,1-4-1.67c-.63-.59-1.15-3.44-1.86-3.64-3.17-.88-8.88,5.27-10.68,7.16C326.45,137.75,318.36,144.55,322,146.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.39,231.21c-1.88-3.49-10.11-7-4.65-11a45.91,45.91,0,0,1,9.44-4.93c4.78-2,6.48-6.6,4.06-10.41a5.76,5.76,0,0,1-1-2.7c-.2-3.52,5.05-4.36,8.07-5.63s5-3.21,4.67-5.95c-.34-3-3.66-4.34-5.67-6.59-4.82-5.42,5.62-10.33,7.43-15.35,1.24-3.44-.5-5.87-3.26-8.42-2.25-2.09-5.38-4.63-4-7.63,1.2-2.6,5.51-3.46,7.63-5.58a10.33,10.33,0,0,0,3.1-7.35,9.59,9.59,0,0,0-2.65-6.43c-2.42-2.63-7-4.88-5.29-8.65.76-1.68,2.49-2.43,2.59-4.4a6.41,6.41,0,0,0-2.09-4.51,27.22,27.22,0,0,0-8.08-5.47c-3.62-1.6-10.17-1.65-10.08,2.8a5.45,5.45,0,0,0,1.64,3.45c.69.74,3.11,2.05,3.08,2.87s-2,2.63-2.53,3.46a23.24,23.24,0,0,0-2.67,7.6,28.42,28.42,0,0,0,.17,10.68c.29,1.45,1.18,3,.64,4.42s-2,2.38-3.47,3.11c-2.31,1.16-5.26,1.75-7.09,3.43-2.89,2.65-.8,5.61,1.26,8.12,1.86,2.27,4.31,5.23,1.92,7.84-1.73,1.88-5.16,2-7,3.69-2.54,2.27-.19,4.08,1,6.36,1.52,3,.81,5.8-1.63,8.33-4,4.18-15.9,5.72-13.49,12,.61,1.59,1.43,2.56,1.4,4.28s-.82,3.6-.58,5.45c.37,2.94,3.08,5.3,3.64,8.17,1.14,5.91-9,7.82-3.72,13.68a9.88,9.88,0,0,1,2.66,4.22c.25,1-.83,4.23-.31,4.88,2.33,2.87,10.66.13,13.26-.7C367.86,237.3,378.64,235.36,376.39,231.21Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.47,223.34s-1,23.33-39.18,23.33-39.18-23.33-39.18-23.33Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-1",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hourglass--inject-1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "360.73 407.87 297.04 290.15 233.35 407.87 360.73 407.87",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.73 208.72 297.04 326.43 233.35 208.72 360.73 208.72",
    style: {
      fill: "#0D6EFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M308.71,278.22l-9.32,17.22a2.67,2.67,0,0,1-4.7,0l-9.32-17.22a10.21,10.21,0,0,1,9-15.06h5.39A10.21,10.21,0,0,1,308.71,278.22Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.05,378.15,327,390.05a2.67,2.67,0,0,1-1,5.13H268.13a2.67,2.67,0,0,1-1-5.13L296,378.15A2.65,2.65,0,0,1,298.05,378.15Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.04,
    cy: 351.8,
    r: 3.71,
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.04,
    cy: 313.05,
    r: 1.91,
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.04,
    cy: 331.52,
    r: 2.17,
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.41,402.06H233.67a5.82,5.82,0,0,0-5.8,5.81h0a5.82,5.82,0,0,0,5.8,5.8H360.41a5.82,5.82,0,0,0,5.8-5.8h0A5.82,5.82,0,0,0,360.41,402.06Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.41,202.92H233.67a5.82,5.82,0,0,0-5.8,5.8h0a5.82,5.82,0,0,0,5.8,5.8H360.41a5.82,5.82,0,0,0,5.8-5.8h0A5.82,5.82,0,0,0,360.41,202.92Z",
    style: {
      fill: "#0D6EFD"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "194.63 405.68 187.58 403.39 191.96 386.76 199.01 389.05 194.63 405.68",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.47,402.45l7.92,2.57a.54.54,0,0,1,.37.65l-1.65,6.4a1.31,1.31,0,0,1-1.64.85c-2.74-.94-4-1.53-7.49-2.66-2.15-.7-9.21-2.52-12.17-3.48s-1.93-3.86-.59-3.72c6,.63,11.4.35,13.9-.57A2.09,2.09,0,0,1,187.47,402.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.01 389.06 191.96 386.76 189.7 395.34 196.76 397.63 199.01 389.06",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.28,220.72s-12.65,58.55-15.62,79.6c-3.25,23.05-15.46,92.27-15.46,92.27l13.09,3.62s18.14-67.13,23.44-89.54c5.75-24.33,21-86,21-86Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.92,239.92c-5,11.34-7.47,36-5.53,47.35,3.54-14.55,7.8-31.85,11.09-45.16C238.37,238.25,236.53,234,233.92,239.92Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.62 396.47 186.6 392.61 186.88 386.9 202.66 392.35 200.62 396.47",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.57,402.87a9.63,9.63,0,0,0,2,.36.18.18,0,0,0,.16-.28c-.18-.23-1.73-2.24-2.7-2.18a.65.65,0,0,0-.54.34,1,1,0,0,0-.08,1A2,2,0,0,0,184.57,402.87Zm1.59,0c-1.34-.16-2.26-.5-2.48-.93a.62.62,0,0,1,.07-.63.32.32,0,0,1,.26-.17C184.53,401.08,185.51,402.06,186.16,402.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.5,403.22h.08a.18.18,0,0,0,.13-.11c0-.08.85-2.06.36-3a.85.85,0,0,0-.62-.45.66.66,0,0,0-.76.3c-.41.72.16,2.53.73,3.18Zm0-3.17a.5.5,0,0,1,.31.26,3.85,3.85,0,0,1-.27,2.39,3.52,3.52,0,0,1-.51-2.53c0-.09.14-.19.39-.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.74,165.13c-.38.9-.7,1.58-1.05,2.34s-.73,1.46-1.1,2.18c-.74,1.45-1.52,2.86-2.33,4.27a82.48,82.48,0,0,1-5.4,8.18,62,62,0,0,1-6.65,7.59,38.5,38.5,0,0,1-8.68,6.42l-.25.13a5.17,5.17,0,0,1-1.28.46,14.21,14.21,0,0,1-6.87-.27,20,20,0,0,1-5.24-2.44,34,34,0,0,1-7.24-6.56,60.17,60.17,0,0,1-5.27-7.31,65.7,65.7,0,0,1-4.13-7.85,3.24,3.24,0,0,1,5.47-3.35l.1.12c1.65,2,3.44,4.13,5.24,6.07a68.41,68.41,0,0,0,5.58,5.48,27.46,27.46,0,0,0,5.74,4,8.46,8.46,0,0,0,2.47.82,2.74,2.74,0,0,0,1.44-.12l-1.53.59a29.94,29.94,0,0,0,5.61-4.9,61.91,61.91,0,0,0,5-6.42c1.58-2.3,3.08-4.71,4.49-7.19.72-1.23,1.41-2.48,2.06-3.75l1-1.89c.31-.61.65-1.31.89-1.8l.06-.14a6.5,6.5,0,0,1,11.85,5.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.39,178.71c3.14-8.34,9.81-8.48,12.7-6.27-.21.39-.43.78-.65,1.17a84.91,84.91,0,0,1-5.15,7.91A65.35,65.35,0,0,1,216,188.9c-.72.71-1.46,1.41-2.23,2.09A32,32,0,0,1,215.39,178.71Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,172.79l-6.5.24,1.62-6.95a33.54,33.54,0,0,1,6.63,1,2.63,2.63,0,0,1,1.41,4h0A3.91,3.91,0,0,1,176,172.79Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.64,166.92a6.28,6.28,0,0,0-2.15-1.11c-.54,2.84-4,7.63-4,7.63h2.71a2.38,2.38,0,0,0,1.83-.85l1.9-2.28A2.37,2.37,0,0,0,179.64,166.92Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.52 169.83 166.34 164.93 171.1 166.09 169.48 173.03 164.52 169.83",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.25 408.92 238.84 408.92 238.58 391.75 245.99 391.75 246.25 408.92",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.45,408.06h8.33a.53.53,0,0,1,.55.51l.4,6.59a1.32,1.32,0,0,1-1.3,1.32c-2.9-.05-4.28-.22-8-.22-2.25,0-9.78.23-12.89.23s-3-3.08-1.71-3.36c5.92-1.24,11.2-3,13.29-4.61A2.07,2.07,0,0,1,238.45,408.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246 391.76 238.58 391.76 238.72 400.61 246.13 400.61 246 391.76",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.74,220.72s-2.83,64.41-1.63,85.64c1.32,23.24,4.08,92.11,4.08,92.11h13.58s3.42-67,4.24-90c.89-25,4.92-87.75,4.92-87.75Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.32 398.47 234.65 398.47 233.53 393.01 249.72 393.82 249.32 398.47",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.82,409.35a9.69,9.69,0,0,0,2-.26.2.2,0,0,0,.13-.14.19.19,0,0,0-.07-.17c-.24-.17-2.34-1.6-3.25-1.24a.66.66,0,0,0-.4.48,1,1,0,0,0,.22.94A2,2,0,0,0,235.82,409.35Zm1.5-.51c-1.33.26-2.3.22-2.65-.12a.64.64,0,0,1-.12-.62.3.3,0,0,1,.19-.24C235.23,407.67,236.46,408.29,237.32,408.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.76,409.09a.13.13,0,0,0,.08,0,.18.18,0,0,0,.09-.14c0-.09.17-2.22-.58-2.94a.87.87,0,0,0-.73-.24.66.66,0,0,0-.62.52c-.18.81.93,2.36,1.67,2.8A.15.15,0,0,0,237.76,409.09Zm-1-3a.5.5,0,0,1,.37.15,3.83,3.83,0,0,1,.49,2.36c-.64-.55-1.38-1.73-1.27-2.26,0-.1.08-.22.33-.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.64,160.94a4.72,4.72,0,0,0-4-5.5h-.08c-2.39-.35-5.39-.71-8.33-.85a147.89,147.89,0,0,0-16.85,0c-2.59.24-5.12.67-7.14,1.06l-.08,0a7.08,7.08,0,0,0-5.39,4.94c-2.42,8.15-5.31,24.79-1.53,60.12h39.65c.28-3.54-.51-15.06.07-29.73A234.86,234.86,0,0,1,261.64,160.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.26,163.12c-.82,4.74-1.83,11.19-2.53,18,0,0-3.62-7.1-4.28-13.17S259,161.42,261.26,163.12Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.67,164.06a.38.38,0,0,1-.17-.71l12.36-6.41a.38.38,0,0,1,.5.16.38.38,0,0,1-.16.51L234.84,164A.47.47,0,0,1,234.67,164.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.33,164.64a.33.33,0,0,1-.26-.11l-6.78-6.73a.39.39,0,0,1,0-.53.38.38,0,0,1,.53,0l6.77,6.74a.38.38,0,0,1,0,.53A.36.36,0,0,1,240.33,164.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.26,154.58a147.71,147.71,0,0,0-16.84,0l-.28,0a4,4,0,0,0,.43,3.07c.94,1.5,2.91,2.34,5.87,2.5l1.11,0c8,0,11.09-4.86,11.22-5.07l.28-.45Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M233.22,154.52c4.9-1.16,5.76-4.19,5.43-7.52a19.92,19.92,0,0,0-.39-2.48l6.14-5.1,4.51-3.74c-1.25,5.43-2.66,15.32,1,18.94,0,0-3,5-11.43,4.56C231.41,158.79,233.22,154.52,233.22,154.52Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.26,144.52a19.92,19.92,0,0,1,.39,2.48c2.29-.46,5.35-2.9,5.67-5.24a10.66,10.66,0,0,0,.08-2.34Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,118.5c-3.33,2-2.8,7-3.7,10.58,2.12.21,5.46-3.56,5.46-3.56l2-5.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.71,128.56c-2.13,7.06-3,11.29-7.52,14.24a9.59,9.59,0,0,1-14.92-8.11c0-6.73,3.46-17.15,11.18-18.59A9.7,9.7,0,0,1,252.71,128.56Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.06,134.55c5-5.8-1.25-8.66,3.86-12.69-5.75.27-15.22-.14-16.91-4.08s3.51-9.28,7.84-9.78c5-.58,3.92,5.61,3.92,5.61s19.13-1.19,13.06,7c4.6-.28,3.33,7.16-4.67,13.44C251.15,134.72,246.06,134.55,246.06,134.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.68,120.71s3.94-1.17,3.81-4.29C261.91,117.4,262.06,120.38,256.68,120.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.88,135.93a7.91,7.91,0,0,1-4.55,2.77c-2.27.41-2.8-1.69-1.67-3.74,1-1.84,3.43-4.27,5.47-3.76S255.33,134.14,253.88,135.93Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.32,128.38c-.14.58-.56,1-.95.91s-.58-.61-.44-1.19.56-1,.94-.92S241.46,127.79,241.32,128.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.69,127.05c-.14.58-.56,1-.94.92s-.59-.61-.45-1.19.56-1,.94-.92S234.83,126.47,234.69,127.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.73,127.76a22.22,22.22,0,0,1-4,4.42,3.42,3.42,0,0,0,2.68,1.09Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.45,135.31a5.13,5.13,0,0,0,3.85-1.24.16.16,0,0,0,0-.24.18.18,0,0,0-.25,0,4.89,4.89,0,0,1-4.22,1.05.17.17,0,0,0-.2.14.18.18,0,0,0,.14.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.88,126.76a.27.27,0,0,0,.17,0,.34.34,0,0,0,.17-.46,3.36,3.36,0,0,0-2.47-2,.36.36,0,0,0-.4.3.35.35,0,0,0,.31.39,2.69,2.69,0,0,1,1.92,1.58A.36.36,0,0,0,243.88,126.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.05,123.07a.32.32,0,0,0,.32-.06,2.89,2.89,0,0,1,2.52-.59.35.35,0,1,0,.22-.67h0a3.64,3.64,0,0,0-3.17.71.35.35,0,0,0-.06.49A.3.3,0,0,0,233.05,123.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,158.09l.83,1.13.75,1.06c.5.71.95,1.42,1.42,2.13.91,1.43,1.77,2.88,2.6,4.34a95.76,95.76,0,0,1,4.52,9c.7,1.52,1.3,3.1,1.94,4.65s1.18,3.16,1.67,4.78a88.81,88.81,0,0,1,2.6,9.83l.08.38a5.22,5.22,0,0,1-.71,3.94,28.6,28.6,0,0,1-4.55,5.39,23.54,23.54,0,0,1-6,4,21.55,21.55,0,0,1-6.86,1.9,20.48,20.48,0,0,1-3.5.06c-.58,0-1.16-.11-1.74-.2l-.88-.17-1-.25a.46.46,0,0,1-.34-.55l1.38-5.8c0-.05.26-.06.42-.1l.55-.11c.38-.08.75-.17,1.13-.27a15.91,15.91,0,0,0,2.17-.76,15.5,15.5,0,0,0,3.79-2.23,19.16,19.16,0,0,0,5.26-6.85l-.63,4.32c-.86-2.83-1.77-5.63-2.87-8.4s-2.3-5.49-3.61-8.17-2.71-5.33-4.22-7.91c-.74-1.29-1.52-2.56-2.3-3.82l-1.19-1.86-.59-.9-.55-.8-.2-.3A6.49,6.49,0,0,1,262,158.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.78,209.48,246.63,213l9.33-.37s2.45-6.28-.89-7.27l-1.3.35A8.56,8.56,0,0,0,248.78,209.48Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.62,204.55a6.26,6.26,0,0,0-1.7,1.71c2.54,1.38,6.08,6.08,6.08,6.08l.82-2.58a2.38,2.38,0,0,0-.27-2L256,205.26A2.38,2.38,0,0,0,252.62,204.55Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.45 218.42 255.14 217.74 255.96 212.63 246.63 213 247.45 218.42",
    style: {
      fill: "#ff8b7b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clock--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.06,96.34l-.51-.86a35.39,35.39,0,0,1,4.57-2.28l.38.93A33.38,33.38,0,0,0,153.06,96.34Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.46,114l-1-.34A34.81,34.81,0,0,1,149.77,97.3l.59.81A33.7,33.7,0,0,0,138.46,114Z",
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.2,
    cy: 125.39,
    r: 30.78,
    style: {
      fill: "#0D6EFD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.91,125.39a25.71,25.71,0,1,1-6.72-17.34.06.06,0,0,1,.05,0A25.66,25.66,0,0,1,195.91,125.39Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.91,125.39a25.71,25.71,0,0,1-43.15,18.89,25.71,25.71,0,0,1,36.43-36.23.06.06,0,0,1,.05,0A25.66,25.66,0,0,1,195.91,125.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.2,126.89a1.49,1.49,0,0,1-1.06-.44L156.6,113.91a1.5,1.5,0,1,1,2.12-2.12l11.48,11.48,6.63-6.63a1.5,1.5,0,0,1,2.12,2.12l-7.69,7.69A1.51,1.51,0,0,1,170.2,126.89Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingTime);
export default __webpack_public_path__ + "static/media/waiting-time.d96b0101cda59ef8781891ff478a2187.svg";
export { ForwardRef as ReactComponent };